import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import { withNext } from '../ui/context';
import { FontSizeControl } from '../ui/font-size-control';
var FontSizePicker = process.env.COMPONENT_SYSTEM_PHASE === 1 ? function (props, ref) {
  // @todo Wrapped with div.components-base-control for spacing reasons.
  // Remove this when the inner Typography Tools component uses VStack
  // to automatically space elements apart vertically.
  return createElement("div", {
    className: "components-base-control"
  }, createElement(FontSizeControl, _extends({}, props, ref ? {} : {
    ref: ref
  })));
} : undefined;
export function withNextComponent(current) {
  return withNext(current, FontSizePicker, 'WPComponentsFontSizePicker');
}
//# sourceMappingURL=next.js.map